import React from "react";
import BackgroundImage from "../../assets/images/LoginBackgroundNew.png";
import Button from "../Buttons/Button";

const DocumentCard = ({
  title = "TEST-1.pdf",
  description = "20 PAGES",
  image = BackgroundImage,
  height = "h-64",
  width = "w-48",
}) => {
  return (
    <div
      className={`relative rounded-md shadow overflow-hidden ${height} ${width} bg-center bg-cover bg-no-repeat`}
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <div className="absolute bottom-0 left-0 right-0 bg-white bg-opacity-90 px-3 py-3">
        <div className="flex justify-between items-start">
          {/* Left side: title + description stacked */}
          <div className="flex flex-col">
            <p className="text-sm font-medium text-gray-800 truncate">
              {title}
            </p>
            <p className="text-xs text-gray-500 mt-1">{description}</p>
          </div>

          <Button
            type="icon"
            color="black"
            icon={"more_vert"}
            variant="text"
            className="mb-8"
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;
